import React from 'react'
import CheckHotlineContext from "../context/CheckHotlineContext"
import PropTypes from "prop-types"

CheckHotlineProvider.propTypes = {
    listJobCheck: PropTypes.array.isRequired,
    onChangeValueId: PropTypes.string.isRequired,
    onShowModalListHotline: PropTypes.func.isRequired,
    fetchListJobCheckHotline: PropTypes.func.isRequired
}


function CheckHotlineProvider(props) {
    const {
        listJobCheck,
        onChangeValueId,
        onShowModalListHotline,
        fetchListJobCheckHotline
    } = props

    return (
        <CheckHotlineContext.Provider
            value={{
                listJobCheck,
                onChangeValueId,
                onShowModalListHotline,
                fetchListJobCheckHotline
            }}
        >
            {props.children}
        </CheckHotlineContext.Provider>
    )
}

export default CheckHotlineProvider